module.exports = "/images/menu-add-document.svg?61cc49b7be75020f6a22ecb5784396cf";